import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { casosClinicos } from '../../mocks/casos-clinicos';

export default function CasosClinicosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-gray-800 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            <strong>Casos Clínicos</strong> de Cirugía Veterinaria
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed">
            Casos reales de <strong>cirugía veterinaria especializada en Almería</strong>. Resultados documentados de TPLO, fracturas, oncología y neurocirugía.
          </p>
        </div>
      </section>

      {/* Casos Grid - Próximamente */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center py-16">
            <div className="w-24 h-24 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="ri-time-line text-teal-600 text-5xl"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Próximamente
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed mb-8">
              Estamos preparando una selección de <strong className="text-teal-600">casos clínicos reales</strong> con resultados documentados de cirugías especializadas en Almería y Granada.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
              <span className="px-4 py-2 bg-gray-100 rounded-full">Neurocirugía</span>
              <span className="px-4 py-2 bg-gray-100 rounded-full">Ortopedia (TPLO)</span>
              <span className="px-4 py-2 bg-gray-100 rounded-full">Fracturas</span>
              <span className="px-4 py-2 bg-gray-100 rounded-full">Oncología</span>
              <span className="px-4 py-2 bg-gray-100 rounded-full">Cirugía Tejidos Blandos Avanzada</span>
              <span className="px-4 py-2 bg-gray-100 rounded-full">Cirugía Torácica</span>
              <span className="px-4 py-2 bg-gray-100 rounded-full">Cirugía Vías Aéreas</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Tu Paciente Necesita <strong>Cirugía Especializada</strong>?
          </h2>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Contacta conmigo para valoración de casos complejos en <strong>Almería</strong> y provincia. Servicio móvil en tu clínica.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="tel:+34600581975"
              className="inline-flex items-center justify-center space-x-2 bg-gray-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}